import uly from "ulysses/core";
import config from "site_config";
import $ from "jquery";
import Globalize from "globalize";
import login_template from "ulysses/login.html";
import timeout_template from "ulysses/inactivity.html";
import ko from "knockout";
import HalResource from "ulysses/api";
import "ulysses/core_widgets";
import "ulysses/core_controls";
import "ulysses/features/core_features";

//"jquery-libs/resize",
import "jquery-libs/icheck";

import "adminlte";
"use strict";

var web_root = uly.utils.get_root();
var api_root = config.api_root;
var io_root = config.io_root;
uly.site_properties = config;

var login_dialog = null;

var do_login_dialog = function do_login_dialog(user,pwd, error) {
    if (login_dialog) {
        return login_dialog;
    }
    // hardcode buttons for now
    var login_buttons = [
        {
            "button":"ok", "caption":_("ulysses_button_login", "Sign in"), "icon":"fa-check",
            "button_class":"btn btn-social bg-primary btn-block"
        }

    ];
    login_dialog = uly.dialogs.execute(login_template, { 
        "keyboard":true, 
        "custom":true, 
        "color":"blue", 
        "title":_("app_title_sign_in_to_ulysses", "Sign In To Ulysses"), 
        "buttons": login_buttons 
    }, { 
        "username":user, 
        "password":pwd, 
        "error":error || false 
    });
    login_dialog.then((res) => {login_dialog = null; }, (res) => { login_dialog = null; });
    return login_dialog;
};

var timeout_prompt = function(timeout) {
    var dialog_data = { "timeout": ko.observable(Math.ceil(timeout / 1000)) };
    var expiry_date = new Date().getTime() + timeout;
    setInterval(function() {
        var timeout_left = (expiry_date - new Date().getTime());
        dialog_data.timeout(Math.ceil(timeout_left/1000));
    }, 1000);
    return uly.dialogs.execute(timeout_template, { "keyboard":true, "title":_("app_title_inactivity_warning", "Inactivity Warning"), "raw_data":true, "buttons":[
        {"button":"ok", "caption":_("app_caption_continue_working", "Continue Working"), "icon":"fa-check"},
        {"button":"cancel", "caption":_("app_caption_log_out", "Log out"), "icon":"fa-cancel"}
    ]}, dialog_data);
};

var logout = function() {
    uly.actions.logout();
};

var initialise_app = function initialise_app(app_data) {
    var app_resource = HalResource(app_data);
    var app_def = Promise.Deferred();

    app_resource.follow("uly:user").then(function(auth_data) {
        console.log("starting app success:", auth_data);
        // NOTE: variant used to be: uly.utils.is_mobile() ? "touchdevice" : "desktop"
        // However we disable that for now, as this causes confusion, extra work and bad
        // expectations for newfangled hybrid laptops
        uly.start_ulysses(app_data, auth_data, "desktop");
        uly.initialise_timeout(timeout_prompt, logout);
        app_def.resolve(app_data);

    }, function(auth_err) {
        //at this point we are initialising the app for anonymous.
        // NOTE: variant used to be: uly.utils.is_mobile() ? "touchdevice" : "desktop"
        // However we disable that for now, as this causes confusion, extra work and bad
        // expectations for newfangled hybrid laptops
        uly.start_ulysses(app_data, null, "desktop");
        app_def.resolve(app_data);
        //console.error("error navigating:", arguments);
        //app_def.reject(error);
    });


    return app_def;
};

var update_app = function update_app(app_data, rememberMe) {
    var app_resource = HalResource(app_data);
    var app_def = Promise.Deferred();
    if (app_data.token) {
        uly.api.setToken(app_data.token);
    }
    app_resource.follow("uly:user").done(function(auth_data) {
        // NOTE: variant used to be: uly.utils.is_mobile() ? "touchdevice" : "desktop"
        // However we disable that for now, as this causes confusion, extra work and bad
        // expectations for newfangled hybrid laptops
        uly.update_ulysses(app_data, auth_data, "desktop");
        uly.initialise_timeout(timeout_prompt, logout);
        app_def.resolve(app_data);

    }).fail(function(error) {
        app_def.reject(error);
    });

    return app_def;
};

var authenticate = function authenticate(username, password, rememberMe) {
    return uly.api.start()
        .post("uly:users", { "username":username, "password":password, "source":"token" })
        .then(function(auth_data) {
            if (auth_data.token) {
                uly.api.setToken(auth_data.token);
            }
            return HalResource(auth_data).follow("uly:app").then(function(app_data) {
                if (rememberMe) {
                    localStorage.token = auth_data.token;
                } else {
                    sessionStorage.token = auth_data.token;
                }
                return app_data;
            });
        });
};

function get_re_login(username, password, rememberMe) {
    var relogin = function() {
        authenticate(username, password, rememberMe).done(function(app_data) {
            update_app(app_data).fail(function(result) {
                login_and_start(username, password, result.error);
            });
        }).fail(function(result) {
            login_and_start(username, password, result.error);
        });
    };
    return relogin;
}

function login_and_start(user, pwd, error) {
    if (error && typeof error == "function") {
        console.error("got network error:", error);
        error = _("app_login_and_start_an_error_occurred", "An error occurred.");
    }
    do_login_dialog(user,pwd, error).then(function([result, data, button]) {
        if (button == "signin" || button == "ok") {
            var username = ko.unwrap(result.username);
            var password = ko.unwrap(result.password);
            var rememberMe = ko.unwrap(result.remember_me);
            authenticate(username, password, rememberMe)

                .then(
                    initialise_app, 
                    (result) => {
                        console.error("Error authenticating:", result);
                        if (result) {
                            if (result.status && result.responseJSON && result.responseJSON.error) {
                                result = result.responseJSON;
                            }
                        }
                        return login_and_start(username, password, result.error);
                    }
                );
        } else if (button == "signup") {
            uly.actions.signup(null, null, {});
        } else if (uly.actions[button]) {
            uly.actions[button](null, null, {});
        }
    });
}
uly.actions.login = function(ev, $elt, ui, maybe_error) {

    login_and_start(null, null, maybe_error);
};
//initialise the api with our new root
uly.initialise_apis(web_root, io_root, {}, api_root);

function initialise_token_from_storage_or_initial_url() {
    var token = null;
    //hack: get the token from url if we are impersonating.
    var state = uly.history.get_parsed_state();
    var toks = state.fragment.split("/");
    var ip = toks.indexOf("impersonate");
    if (ip >= 0) {
        token = toks[ip + 1];
    }

    if (!token) {

        token = sessionStorage.token || localStorage.token;
    }
    if (token && token !== "undefined") {
        uly.api.setToken(token);
        sessionStorage.token = token;
    }
}

function load_script(url) {

    if(Array.isArray(url)) {
        var self = this, prom = [];
        url.forEach(function(item) {
            prom.push(load_script(item));
        });
        return Promise.all(prom);
    }

    return new Promise(function (resolve, reject) {
        var r = false,
            t = document.getElementsByTagName("script")[0],
            s = document.createElement("script");

        s.type = "text/javascript";
        s.src = url;
        s.async = true;
        s.onload = s.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState == "complete")) {
                r = true;
                resolve(this);
            }
        };
        s.onerror = s.onabort = reject;
        t.parentNode.insertBefore(s, t);
    });

}

uly.start = function() {
    initialise_token_from_storage_or_initial_url();
    //now try to get app info, if we fail, try to login
    uly.api
        .start()
        .follow("uly:app")
        .then(function(app_data) {
            //TODO: KILL ME: REAL BAD HACK to NOT CHANGE SERVER SIDE FOR NOW
            var __define = window.define;
            window.define = function(stuff, callback) {
                callback(uly, $, ko, HalResource);
            };
            return load_script([uly.api_root + "registered_actions.js", uly.api_root + "bootstrap_clientscripts.js"]).then(function() {
                window.define = __define;
                return initialise_app(app_data);
            });
        }, function(err) {
            //todo
            console.error("No app:", err);
            login_and_start();
        });
};

$(function() { uly.start(); });
